import Parse from "parse";

import { MessageData } from "../../features/messages";
import type { Media } from "./Media";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface MessageAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  classname: string;
  content?: string;
  data?: MessageData;
  displayAt?: Date;
  media: Parse.Relation<Message, Media>;
  referencedObjectId: string;
  tenant?: OD3_Tenant;
  title?: string;
  user?: _User;
}

export class Message extends Parse.Object<MessageAttributes> {
  static className: string = "OD3_Maintenance_Message";

  constructor(data?: Partial<MessageAttributes>) {
    super("OD3_Maintenance_Message", data as MessageAttributes);
  }

  get classname(): string {
    return super.get("classname");
  }
  set classname(value: string) {
    super.set("classname", value);
  }
  get content(): string | undefined {
    return super.get("content");
  }
  set content(value: string | undefined) {
    super.set("content", value);
  }
  get data(): MessageData | undefined {
    return super.get("data");
  }
  set data(value: MessageData | undefined) {
    super.set("data", value);
  }
  get displayAt(): Date | undefined {
    return super.get("displayAt");
  }
  set displayAt(value: Date | undefined) {
    super.set("displayAt", value);
  }
  get media(): Parse.Relation<Message, Media> {
    return super.relation("media");
  }
  get referencedObjectId(): string {
    return super.get("referencedObjectId");
  }
  set referencedObjectId(value: string) {
    super.set("referencedObjectId", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Message", Message);
